import { Partition } from '../types/Partition';

export const partitionToComponentKey = (partition: Partition): string => {
  return partition.map(k => String(k)).join('-');
};
